export default function TopBar() {
  return (
    <header className="topbar" data-testid="top-bar">
      <span className="wordmark" data-testid="wordmark">
        Creatividad<sup className="wm-2">2</sup>
      </span>
      <img
        className="topbar-logo"
        src={`${process.env.PUBLIC_URL}/assets/img/logo-adrianavmarquez.png`}
        alt="Adriana V. Márquez"
        data-testid="logo-adriana"
      />
    </header>
  );
}
